var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMusicIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.417 13.5V3.75l9-1.5V12",
    stroke: "#51DC8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.167 15.75a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zM14.166 14.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z",
    stroke: "#51DC8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicIcon);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOSAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNDE2NSAxMy41VjMuNzVMMTYuNDE2NSAyLjI1VjEyIiBzdHJva2U9IiM1MURDOEUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik01LjE2NjUgMTUuNzVDNi40MDkxNCAxNS43NSA3LjQxNjUgMTQuNzQyNiA3LjQxNjUgMTMuNUM3LjQxNjUgMTIuMjU3NCA2LjQwOTE0IDExLjI1IDUuMTY2NSAxMS4yNUMzLjkyMzg2IDExLjI1IDIuOTE2NSAxMi4yNTc0IDIuOTE2NSAxMy41QzIuOTE2NSAxNC43NDI2IDMuOTIzODYgMTUuNzUgNS4xNjY1IDE1Ljc1WiIgc3Ryb2tlPSIjNTFEQzhFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTQuMTY2NSAxNC4yNUMxNS40MDkxIDE0LjI1IDE2LjQxNjUgMTMuMjQyNiAxNi40MTY1IDEyQzE2LjQxNjUgMTAuNzU3NCAxNS40MDkxIDkuNzUgMTQuMTY2NSA5Ljc1QzEyLjkyMzkgOS43NSAxMS45MTY1IDEwLjc1NzQgMTEuOTE2NSAxMkMxMS45MTY1IDEzLjI0MjYgMTIuOTIzOSAxNC4yNSAxNC4xNjY1IDE0LjI1WiIgc3Ryb2tlPSIjNTFEQzhFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };